import api from './index.js';

/* legacy code here */
api.internals.legacy.setLegacy();

export default api;
